export enum GraphQLErrorCodes {
  NOT_FOUND = 'NOT_FOUND',
  RATE_LIMIT = 'RATE_LIMIT',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  CRM_ERROR = 'CRM_ERROR',
}
